export default __webpack_public_path__ + "static/media/login-background.e41cb35f.png";